/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import * as Yup from 'yup';

import { isValidEmail } from '../../utils/validators';

export const emailConfigValidationSchema = Yup.object({
  smtpHost: Yup.string()
    .nullable()
    .when('useSmtp', {
      is: true,
      then: Yup.string().trim().required('empty'),
    }),
  smtpPort: Yup.string()
    .nullable()
    .when('useSmtp', {
      is: true,
      then: Yup.string().required('empty'),
    }),
  smtpSecure: Yup.boolean().nullable(),
  smtpUser: Yup.string().nullable().when('useSmtp', {
    is: true,
    then: Yup.string().trim(),
  }),
  smtpPass: Yup.string().nullable().when('useSmtp', {
    is: true,
    then: Yup.string().trim(),
  }),
  enquiryEmails: Yup.string()
    .required('empty')
    .test('array of emails', 'invalid_email', function (value: string) {
      return (value || '').split(/[\s,\s]+/).every(isValidEmail);
    }),
  enquiryEmailLanguage: Yup.string().trim().required('empty'),
  smtpFromEmail: Yup.string()
    .email('invalid_email')
    .nullable()
    .test('required-when-smtp-user-empty', 'either_or', function (val) {
      const { smtpUser, useSmtp } = this.parent;
      if (!useSmtp) {
        return true;
      }
      if (!smtpUser) {
        return !!val;
      }
      return true;
    }),
  emailAddress: Yup.string().nullable().when('useSmtp', {
    is: false,
    then: Yup.string().email(),
    otherwise: Yup.string().nullable(),
  }),
  emailToken: Yup.string().nullable().when('useSmtp', {
    is: false,
    then: Yup.string(),
    otherwise: Yup.string().nullable(),
  }),
});
